import { useSuspenseBIMClass } from "../../../../../../clients/taxonomy/useBIMClass";

export default function useComponentType(id: string, bimClassID: string) {
    const bimClassQuery = useSuspenseBIMClass(bimClassID);
    const { bimClass } = bimClassQuery.data;

    return bimClass.data.componentTypes.find(
        (componentType) => componentType.id === id
    );
}
